module.exports = __webpack_public_path__ + "img/icon-desktop.71f04af6.svg";